import React from "react";
import { CalendarCheck, CheckCircle2, ClipboardCheck, Plane } from "lucide-react";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, LineChart, Line, PieChart, Pie, Cell, Legend,
} from "recharts";
import * as api from "@/lib/api";
import { useData } from "@/hooks/useData";
import { Loader, SectionCard, StatCard, CHART_COLORS, axisProps, gridProps, tooltipProps } from "@/components/ui";

export default function Reports() {
  const { data } = useData(() => api.dashboard.admin(), []);
  if (!data) return <Loader />;

  const totalDays = data.leave_type_usage.reduce((s, x) => s + x.days, 0);
  const decided = data.approved_leaves + data.rejected_leaves;

  return (
    <>
      <div className="grid gap-3 grid-cols-2 lg:grid-cols-4">
        <StatCard label="Leave Days Taken" value={totalDays} icon={Plane} />
        <StatCard label="Approval Rate" value={decided ? `${Math.round((data.approved_leaves / decided) * 100)}%` : "—"} icon={CheckCircle2} color="green" />
        <StatCard label="Attendance Today" value={`${Math.round((data.present_today / data.total_employees) * 100)}%`} icon={CalendarCheck} color="orange" />
        <StatCard label="Pending Requests" value={data.pending_approvals} icon={ClipboardCheck} color="red" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <SectionCard title="Monthly Leave Trend" subtitle="Requests by start month" className="lg:col-span-3">
          <ResponsiveContainer width="100%" height={260}>
            <LineChart data={data.leave_trend} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
              <CartesianGrid {...gridProps} />
              <XAxis dataKey="month" {...axisProps} />
              <YAxis allowDecimals={false} {...axisProps} />
              <Tooltip {...tooltipProps} />
              <Line type="monotone" dataKey="count" name="Requests" stroke="#225881" strokeWidth={2.5} dot={{ r: 4, fill: "#F5A623", strokeWidth: 0 }} />
            </LineChart>
          </ResponsiveContainer>
        </SectionCard>

        <SectionCard title="Leave Type Mix" subtitle="Days by type" className="lg:col-span-2">
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={data.leave_type_usage} dataKey="days" nameKey="type" innerRadius={50} outerRadius={85} paddingAngle={3} stroke="none">
                {data.leave_type_usage.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
              </Pie>
              <Tooltip {...tooltipProps} />
              <Legend verticalAlign="bottom" iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          </ResponsiveContainer>
        </SectionCard>
      </div>

      <SectionCard title="Leave Days by Department">
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data.dept_usage} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid {...gridProps} />
            <XAxis dataKey="dept" {...axisProps} />
            <YAxis {...axisProps} />
            <Tooltip {...tooltipProps} />
            <Bar dataKey="days" name="Days" fill="#F5A623" radius={[8, 8, 0, 0]} maxBarSize={56} />
          </BarChart>
        </ResponsiveContainer>
      </SectionCard>
    </>
  );
}
